export default class AuthenticationActions {
  static LOGIN = "LOGIN";
  static LOGOUT = "LOGOUT";
}
